import api from 'shared/api'

export const doViewValueProposition = async ({ accessToken }) => {
  return await api.put('/users/view-value-propositon', null, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}
